import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/shortcutElementStyle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import { useHistory } from 'react-router-dom';
import { HeadingSBold } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IShortcutElement {
	icon: React.ReactNode;
	url: string;
	label: string;
}

const ShortcutElement = ({ icon, url, label }: IShortcutElement) => {
	const classes = useStyles();
	const history = useHistory();

	return (
		<Paper
			className={classes.paperStyle}
			elevation={0}
			onClick={() => {
				history.push(url);
			}}
		>
			<div className={classes.iconContainer}>{icon}</div>
			<div className={classes.textWrapper}>
				<HeadingSBold disableMargin color="secondary-light">
					{label}
				</HeadingSBold>
			</div>
		</Paper>
	);
};

export default ShortcutElement;
